import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { addUserWalletCredit } from '../../../api/users';

const useAddUserWalletCredit = (options?: Omit<UseMutationOptions, 'mutationFn'>) => {
  return useMutation({
    mutationFn: addUserWalletCredit,
    ...options,
  });
};

export default useAddUserWalletCredit;
